import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import React, { useEffect, useState } from "react";
import { Rating } from "primereact/rating";
import { Column } from "primereact/column";
import Loading from "../../../../../components/Loading/Loading";
import { useHistory, useLocation } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { AdvancedImage } from "@cloudinary/react";
import { cloudinaryInstance } from "../../../../../utilities/Cloudinary/cloudinaryInstance";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { formatDate } from "../../../../../utilities/formatDate";
import OrderService from "../../../../../service/OrderService";
import { useToastContext } from "../../../../../contexts/ToastContext/ToastContext";
import localeText from "../../../../../locale";

const EvaluateOrder = () => {
  const [ratingProduct, setRatingProduct] = useState(null);
  const [ratingSeller, setRatingSeller] = useState(null);
  const [comment, setComment] = useState("");
  const [commentProductService, setCommentProductService] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingOrder, setIsLoadingOrder] = useState(true);
  const [currentOrder, setCurrentOrder] = useState();

  const history = useHistory();
  const { showErrorToast, showSuccessToast } = useToastContext();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentOrderId = searchParams.get("orderId");

  const orderService = new OrderService();

  const handleGoBack = () => {
    history.push("/dashboard-purchases");
  };

  const orderRate = async () => {
    try {
      setIsLoading(true);

      if (!ratingProduct || !ratingSeller) {
        showErrorToast({ detail: "pleaseProvideRating" });
        setIsLoading(false);
        return false;
      }

      const res = await orderService.postRateOrder(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username"),
        comment,
        commentProductService,
        currentOrder.id,
        ratingProduct,
        ratingSeller
      );

      if (res.messageCode !== 200000) {
        showErrorToast({ code: res.messageCode });

        if (res.messageCode === 500000) console.log(res);
        setIsLoading(false);
      } else {
        showSuccessToast({ detail: "orderRatedSuccessfully" });
        history.push("/dashboard-purchases");
        setIsLoading(false);
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        history.replace("/login", { from: location.pathname });
      }
      console.log(e);
    }
  };

  const getOrders = async () => {
    try {
      setIsLoadingOrder(true);

      const res = await orderService.getPurchases(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username")
      );

      if (res.messageCode !== 200001) {
        showErrorToast({ code: res.messageCode });
        setIsLoadingOrder(false);
      } else {
        setCurrentOrder(
          res.result.find(
            (order) => `${order.id}` === currentOrderId && order.status === "RECEIVED"
          )
        );
        setIsLoadingOrder(false);
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        history.replace("/login", { from: location.pathname });
      }
      setIsLoadingOrder(false);
      console.log(e);
    }
  };

  useEffect(() => {
    getOrders(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isLoadingOrder && <Loading />}

      {!currentOrder && !isLoadingOrder && (
        <div className="card border-1 border-300">
          <div
            className="flex justify-content-center align-items-center"
            style={{ height: "20vh" }}
          >
            <p>{localeText("youDoNotHaveAccessToThisPage")}</p>
          </div>
        </div>
      )}

      {currentOrder && !isLoadingOrder && (
        <div className="card border-1 border-300">
          <div className="w-full flex flex-row flex-wrap justify-content-between align-items-center mb-4 gap-2">
            <Button
              label={localeText("backToOrdersList")}
              className="md:max-w-max w-full"
              icon="pi pi-arrow-left"
              onClick={handleGoBack}
            />
          </div>

          <h3 className="my-4">{localeText("orderInfo")}</h3>
          <hr />

          <DataTable
            className="mt-4 mb-6"
            value={[currentOrder]}
            responsiveLayout="scroll"
            loading={isLoading}
            currentPageReportTemplate={localeText("showingFirstToLast")}
          >
            <Column
              header={localeText("sellerProfilePic")}
              style={{ width: "10%" }}
              body={(order) => {
                return (
                  <div
                    style={{
                      background: `url(${order?.seller?.urlAvatar})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                    className="layout-dashboard-urlavatar"
                  />
                );
              }}
            ></Column>
            <Column field="id" header={"ID"} style={{ width: "20%" }} />
            <Column
              field={"seller.username"}
              style={{ width: "20%" }}
              header={localeText("seller")}
            />
            <Column
              header={localeText("preview")}
              body={(order) => {
                return (
                  <div className="flex">
                    {order.itens
                      .filter((order, index) => index < 7)
                      .map((order) => {
                        return (
                          <div key={`p${order.id}`}>
                            <AdvancedImage
                              cldImg={cloudinaryInstance
                                .image(
                                  order.productVariation
                                    ? order.productVariation.imageid
                                    : order.product.imageid1
                                )
                                .resize(fill().width(50).height(50))
                                .format("webp")}
                              style={{ outline: "1px solid #e0e0e0", outlineOffset: "4px" }}
                              className="border-round mr-3"
                              height={50}
                            />
                          </div>
                        );
                      })}
                  </div>
                );
              }}
              style={{ width: "30%" }}
            />
            <Column
              field="itens.length"
              header={localeText("itemsQuantity")}
              style={{ width: "10%" }}
            />
            <Column
              header={localeText("status")}
              body={(order) => {
                return (
                  <>
                    {order.status === "SENT" && (
                      <span
                        className="team-member-role text-0 p-1 border-round"
                        style={{ backgroundColor: "#42A5F5" }}
                      >
                        {localeText("sent").toUpperCase()}
                      </span>
                    )}
                    {order.status === "PAID" && (
                      <span
                        className="team-member-role text-0 p-1 border-round"
                        style={{ backgroundColor: "#F7B005" }}
                      >
                        {localeText("paid").toUpperCase()}
                      </span>
                    )}
                    {order.status === "RECEIVED" && (
                      <span
                        className="team-member-role text-0 p-1 border-round"
                        style={{ backgroundColor: "#46a748" }}
                      >
                        {localeText("received").toUpperCase()}
                      </span>
                    )}
                  </>
                );
              }}
              field="status"
            ></Column>
            <Column
              header={localeText("date")}
              body={(order) => {
                return <p>{formatDate(new Date(order.date))}</p>;
              }}
              field="date"
            />
          </DataTable>

          <div>
            <label htmlFor="rating" className="font-bold">
              {localeText("rateProduct")}
            </label>
            <Rating
              value={ratingProduct}
              onChange={(e) => setRatingProduct(e.value)}
              className="my-2"
            />
            <label htmlFor="rating" className="font-bold">
              {localeText("rateSeller")}
            </label>
            <Rating
              value={ratingSeller}
              onChange={(e) => setRatingSeller(e.value)}
              className="mt-2 mb-4"
            />

            <label htmlFor="comment" className="font-bold">
              {localeText("comment")} ({localeText("optional")})
            </label>
            <InputTextarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows={5}
              cols={40}
              className="w-full mt-2 mb-4"
              style={{ resize: "none" }}
              maxLength={1000}
            />

            <label htmlFor="comment" className="font-bold">
              {localeText("commentProductService")} ({localeText("optional")})
            </label>
            <InputTextarea
              value={commentProductService}
              onChange={(e) => setCommentProductService(e.target.value)}
              rows={5}
              cols={40}
              className="w-full mt-2 mb-4"
              style={{ resize: "none" }}
              maxLength={1000}
            />

            <Button
              label={localeText("confirmRating")}
              className="my-2"
              onClick={orderRate}
              loading={isLoading}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default EvaluateOrder;
